import { Box, LinearProgress, Typography } from '@mui/material';
import { SpinningLogo } from './SpinningLogo';

export const LoadingScreen: React.FC = () => {
  return (
    <Box
      width="100vw"
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ backgroundColor: 'rgba(0, 0, 0, 0.85)', position: 'relative' }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
        <SpinningLogo size={96} />
        <Typography
          sx={{
            color: 'white',
            fontWeight: 500,
            letterSpacing: '0.03em',
            fontSize: { xs: '0.95rem', sm: '1.05rem' },
          }}
        >
          Carregando...
        </Typography>
      </Box>

      <Box
        sx={{
          position: 'absolute',
          bottom: { xs: 32, sm: 48 },
          left: '50%',
          transform: 'translateX(-50%)',
          width: { xs: '70%', sm: 280 },
        }}
      >
        <LinearProgress
          sx={{
            height: 4,
            borderRadius: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
            '& .MuiLinearProgress-bar': {
              backgroundColor: 'white',
              borderRadius: 2,
            },
          }}
        />
      </Box>
    </Box>
  );
};
